/**
 * @name: order
 * @description:
 * @author: qq2575896094
 * @time: 2024/3/25
 */

const prefix = '/onlinecs/manage/order'

/**
 * 订单列表
 * @type {string}
 */
export const getOrderListUrl = `${prefix}/queryOrderList`

/**
 * 获取配送方式
 * @type {string}
 */
export const getDeliveryWayListUrl = `${prefix}//getDeliveryWayList`

/**
 * 获取来源类型
 * @type {string}
 */
export const getSourceTypeListUrl = `${prefix}/getSourceTypeList`

/**
 * 订单详细信息
 * @type {string}
 */
export const getEshopOrderInfoByCodeUrl = '/onlinecs/service/order/getEshopOrderInfoByCode'

/**
 * 新增订单备注
 * @type {string}
 */
export const addOrderRemark = `/onlinecs/service/order/addOrderRemark`

/**
 * 物流信息
 * @type {string}
 */
export const getShippingInfoDetailUrl = `${prefix}/getShippingInfoDetail`

/**
 * 获取售后单列表
 * @type {string}
 */
export const queryRefundListUrl = '/onlinecs/refund/queryRefundList'

/**
 * 创建仅退款订单
 * @type {string}
 */
export const createOnlyRefund = '/onlinecs/refund/createOnlyRefund'

/**
 * 创建退货退款订单
 * @type {string}
 */
export const createReturnGoodsForRefund = '/onlinecs/refund/createReturnGoodsForRefund'

/**
 * 获取售后单详情
 * @type {string}
 */
export const queryRefundDetailUrl = '/onlinecs/refund/getRefundDetail'

/**
 * 获取换货详情
 * @type {string}
 */
export const queryOrderExchangeDetailUrl = `${prefix}/queryOrderExchangeDetail`

/**
 * 获取换货物流单详情
 * @type {string}
 */
export const queryOrderExchangeLogisticsUrl = `${prefix}/queryOrderExchangeLogistics`
